module.exports = __webpack_public_path__ + "static/img/kongzhuang.279ae87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kongzhuang.jpg
// module id = d8YU
// module chunks = 1